import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import AirFreight from "../../assets/Airfreight.jpg";
import OceanFreight from "../../assets/OceanFreight.jpg";
import ProjectCargo from "../../assets/ProjectCargo.jpg";
import Logistics from "../../assets/Logistics.jpg";
import ReeferExpress from "../../assets/ReeferExpress.jpg";
import WareHouse from "../../assets/WareHouseImg.jpg";

const cardInfo = [
  {
    img: OceanFreight,
    title: "Ocean Freight",
    desc: "Trans World Shipping Company is one of the largest independent NVO carriers in the International Trade Lane, offering reliable ocean freight solutions worldwide.",
    path: "/services/ocean-freight",
  },
  {
    img: WareHouse,
    title: "Warehouse & Distribution",
    desc: "We are constantly improving and expanding our capabilities to provide our customers with an operational system that works seamlessly and cost-effectively, supporting their supply chain management for the benefit of their customers.",
    path: "/services/warehouse-distribution",
  },
  {
    img: AirFreight,
    title: "Air Freight",
    desc: "Our Airfreight division, Consolidated American Aircargo, is recognized in the industry for reliable charter services and time-critical deliveries.",
    path: "/services/airfreight",
  },
  {
    img: ProjectCargo,
    title: "Project Cargo",
    desc: "With an impressive international track record over 40+ years, our senior management handles complex project cargo with precision and expertise.",
    path: "/services/project-cargo",
  },
  {
    img: Logistics,
    title: "Logistics",
    desc: "We are a world-class contract logistics and distribution provider, delivering integrated supply chain solutions for businesses of all sizes.",
    path: "/services/logistics",
  },
  {
    img: ReeferExpress,
    title: "Reefer Express",
    desc: "Regionally based and strategically positioned distribution centers carry our temperature-controlled solutions for sensitive cargo.",
    path: "/services/reefer-express",
  },
];

const LandingDetail = () => {
  return (
    <TheLandingDetail>
      <div className="services-section">
        <div className="section-header">
          <h2>Our Core Services</h2>
          <p>Comprehensive logistics solutions tailored to your needs</p>
          <div className="header-line"></div>
        </div>

        <div className="cards-container">
          {cardInfo.map((card, index) => (
            <div className="service-card" key={index}>
              <Link to={card.path} className="card-link">
                <div className="card-image">
                  <img src={card.img} alt={card.title} loading="lazy" />
                  <div className="image-overlay"></div>
                </div>
                <div className="card-content">
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                  <div className="learn-more">
                    Learn More <span className="arrow">→</span>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </TheLandingDetail>
  );
};

const TheLandingDetail = styled.div`
  width: 100%;
  background: #f8f9fa;
  padding: 5rem 0;

  .services-section {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .section-header {
    text-align: center;
    margin-bottom: 3.5rem;

    h2 {
      font-size: 2.5rem;
      color: #0b1e33;
      font-weight: 700;
      margin-bottom: 1rem;
      letter-spacing: -0.5px;
    }

    p {
      font-size: 1.1rem;
      color: #4a5568;
      margin-bottom: 1.5rem;
    }

    .header-line {
      width: 70px;
      height: 3px;
      background: #d4af37;
      margin: 0 auto;
      border-radius: 2px;
    }
  }

  .cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 2rem;
  }

  .service-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);

      .card-image img {
        transform: scale(1.05);
      }

      .learn-more {
        color: #d4af37;

        .arrow {
          transform: translateX(5px);
        }
      }
    }
  }

  .card-link {
    text-decoration: none;
    display: block;
    color: inherit;
  }

  .card-image {
    position: relative;
    width: 100%;
    height: 220px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.5s ease;
    }

    .image-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.3)
      );
    }
  }

  .card-content {
    padding: 1.5rem;

    h3 {
      font-size: 1.35rem;
      color: #0b1e33;
      font-weight: 700;
      margin-bottom: 0.75rem;
      letter-spacing: -0.3px;
    }

    p {
      font-size: 0.9rem;
      color: #4a5568;
      line-height: 1.6;
      margin-bottom: 1.25rem;
    }

    .learn-more {
      background: none;
      border: none;
      color: #0b1e33;
      font-weight: 600;
      font-size: 0.9rem;
      cursor: pointer;
      padding: 0;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.2s ease;
      font-family: inherit;

      .arrow {
        transition: transform 0.2s ease;
        display: inline-block;
      }
    }
  }

  /* Responsive Breakpoints */
  @media screen and (max-width: 1366px) {
    .cards-container {
      gap: 1.75rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .services-section {
      padding: 0 1.75rem;
    }

    .cards-container {
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 1.5rem;
    }
  }

  @media screen and (max-width: 900px) {
    padding: 4rem 0;

    .section-header {
      margin-bottom: 2.5rem;

      h2 {
        font-size: 2rem;
      }

      p {
        font-size: 1rem;
      }
    }

    .cards-container {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 1.5rem;
    }

    .card-image {
      height: 200px;
    }

    .card-content {
      padding: 1.25rem;

      h3 {
        font-size: 1.2rem;
      }

      p {
        font-size: 0.85rem;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .cards-container {
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 1.25rem;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 3rem 0;

    .services-section {
      padding: 0 1.25rem;
    }

    .section-header {
      margin-bottom: 2rem;

      h2 {
        font-size: 1.75rem;
      }
    }

    .cards-container {
      grid-template-columns: 1fr;
      max-width: 450px;
      margin: 0 auto;
      gap: 1.5rem;
    }

    .service-card {
      max-width: 100%;
    }

    .card-image {
      height: 200px;
    }
  }

  @media screen and (max-width: 480px) {
    .section-header {
      h2 {
        font-size: 1.5rem;
      }

      p {
        font-size: 0.9rem;
      }
    }

    .card-content {
      padding: 1rem;

      h3 {
        font-size: 1.1rem;
      }

      p {
        font-size: 0.8rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .services-section {
      padding: 0 1rem;
    }

    .card-image {
      height: 180px;
    }
  }
`;

export default LandingDetail;
